import React, { useState } from "react";
import { Select, Table } from "antd";

export const TopCategoryChannelPaymenttype = ({ data }) => {
  const uniqueChannels = Array.from(new Set(data?.map((item) => item.channel)));
  const uniquePaymenttype = Array?.from(
    new Set(data?.map((item) => item.paymenttype))
  );
  const uniqueCategories = Array.from(
    new Set(data?.flatMap((item) => item.products.map((i) => i.category)))
  );
  const [filterType, setFilterType] = useState("channel");
  const [selectedFilter, setSelectedFilter] = useState(null);

  const filteredData = data?.filter((item) => {
    if (filterType === "channel") {
      if (selectedFilter && selectedFilter !== item.channel) {
        return false;
      }
    }
    if (filterType === "category") {
      if (selectedFilter && selectedFilter !== item.category) {
        return false;
      }
    }
    if (filterType === "paymenttype") {
      if (selectedFilter && selectedFilter !== item.paymenttype) {
        return false;
      }
    }
    return true;
  });

  const orderCounts = {};
  filteredData?.forEach((order) => {
    const type =
      filterType === "channel"
        ? order.channel
        : filterType === "category"
        ? order.products.map((i) => i.category).join(",")
        : order.paymenttype;
    orderCounts[type] = (orderCounts[type] || 0) + 1;
  });

  const handleFilterTypeChange = (value) => {
    setFilterType(value);
    setSelectedFilter(null);
  };

  const getTotalProductsByFilter = (filterValue) => {
    let total = 0;
    filteredData?.forEach((order) => {
      const filterCondition =
        filterType === "channel"
          ? order.channel === filterValue
          : filterType === "paymenttype"
          ? order.paymenttype === filterValue
          : order.products?.some((item) => item.category === filterValue);
      if (filterCondition) {
        total += order.products?.reduce((acc, item) => acc + item.quantity, 0);
      }
    });
    return total;
  };

  const getTotalAmountByFilter = (filterValue) => {
    let total = 0;
    filteredData?.forEach((order) => {
      const filterCondition =
        filterType === "channel"
          ? order.channel === filterValue
          : filterType === "paymenttype"
          ? order.paymenttype === filterValue
          : order.products.some((item) => item.category === filterValue);
      if (filterCondition) {
        total += order.saleAmount;
      }
    });
    return total;
  };

  const columns = [
    {
      title: (
        <div>
          <Select
            defaultValue={filterType}
            onChange={handleFilterTypeChange}
            className="ml-4 w-36"
          >
            <Select.Option value="channel">Canal</Select.Option>
            <Select.Option value="category">Categoría</Select.Option>
            <Select.Option value="paymenttype">Tipo de pago</Select.Option>
          </Select>
        </div>
      ),
      dataIndex:
        filterType === "channel"
          ? "channel"
          : filterType === "category"
          ? "category"
          : "paymenttype",
      key:
        filterType === "channel"
          ? "channel"
          : filterType === "category"
          ? "category"
          : "paymenttype",
    },
    {
      title: "Total de Ordenes",
      dataIndex: "total",
      key: "total",
      render: (text) => {
        const total = parseFloat(text);
        if (!isNaN(total)) {
          return `${total}`;
        }
        return "";
      },
      width: 120,
      sorter: (a, b) => a.total - b.total,
      sortDirections: ["descend", "ascend"],
      defaultSortOrder: "descend",
    },
    {
      title: "Total de Productos",
      dataIndex: "totalProducts",
      key: "totalProducts",
      width: 120,
      sorter: (a, b) => a.totalProducts - b.totalProducts,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Total Facturado",
      dataIndex: "totalAmount",
      key: "totalAmount",
      width: 120,
      render: (text) => {
        const total = parseFloat(text);
        if (!isNaN(total)) {
          return `S/ ${total.toFixed(2)}`;
        }
        return "";
      },
      sorter: (a, b) => a.totalAmount - b.totalAmount,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "% Total Ordenes",
      dataIndex: "percent",
      key: "percent",
      width: 120,
      render: (_, record) => {
        const total = dataSource.reduce((acc, curr) => acc + curr.total, 0);
        const percent = ((record.total / total) * 100).toFixed(2);
        return `${percent}%`;
      },
    },
  ];

  const dataSource =
    filterType === "channel"
      ? uniqueChannels.map((channel) => ({
          channel,
          total: orderCounts[channel] || 0,
          totalProducts: getTotalProductsByFilter(channel),
          totalAmount: getTotalAmountByFilter(channel),
          key: channel,
        }))
      : filterType === "category"
      ? uniqueCategories.map((category) => ({
          category,
          total: orderCounts[category] || 0,
          totalProducts: getTotalProductsByFilter(category),
          totalAmount: getTotalAmountByFilter(category),
          key: category,
        }))
      : uniquePaymenttype.map((paymenttype) => ({
          paymenttype,
          total: orderCounts[paymenttype] || 0,
          totalProducts: getTotalProductsByFilter(paymenttype),
          totalAmount: getTotalAmountByFilter(paymenttype),
          key: paymenttype,
        }));

  return (
    <div className="w-full pt-4 pr-4 pl-4">
      <div className="overflow-x-auto h-96">
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
      </div>
    </div>
  );
};
